/** How much fits on screen: Comfortable is the default, Compact is the original dense layout. */
export type DensityPreference = "comfortable" | "compact";

export const DENSITY_PREFERENCES: readonly DensityPreference[] = [
  "comfortable",
  "compact"
];

export const isDensityPreference = (
  value: unknown
): value is DensityPreference =>
  typeof value === "string" &&
  (DENSITY_PREFERENCES as readonly string[]).includes(value);
